import { render, staticRenderFns } from "./project-report-issues-list.vue?vue&type=template&id=e307fcac&scoped=true"
import script from "./project-report-issues-list.vue?vue&type=script&lang=js"
export * from "./project-report-issues-list.vue?vue&type=script&lang=js"
import style0 from "./project-report-issues-list.vue?vue&type=style&index=0&id=e307fcac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e307fcac",
  null
  
)

export default component.exports